import { render, staticRenderFns } from "./addSMSTemplate.vue?vue&type=template&id=185c2b9d"
import script from "./addSMSTemplate.vue?vue&type=script&lang=js"
export * from "./addSMSTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports